module.exports = __webpack_public_path__ + "img/BI.e05683e3.svg";